import type { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import {
  faAngleDown,
  faChartLine,
  faCode,
  faCompassDrafting,
  faFileInvoice,
  faGear,
  faMagnifyingGlass,
  faMobileScreenButton,
  faUserTie,
  faPenNib,
  faCamera,
  faWindowMaximize,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { memo, useCallback } from 'react'
import { scroller } from 'react-scroll'

import { BreadCrumbs } from '@/components/UIParts/Breadcrumbs'
import { Heading } from '@/components/UIParts/Heading'

const MarketingList = [
  {
    icon: faFileInvoice,
    label: 'デジタルマーケティング<br class="md:hidden" />戦略立案',
    id: 'digitalMarketing',
    description: () => (
      <>
        コロナ渦の影響で様々な分野のデジタル化が進み、かつてはデジタルと無縁と考えられていた領域にも“DX”の波が訪れるなど、デジタル戦略は企業にとって非常に重要な領域へと変化しました。
        <br />
        弊社ではクライアントの目標や解決したい課題をヒアリングし、GOALまでのビジョン、ロードマップ、必要な成果物や目標KPIなどをともに策定していきます。
        <br />
        オンライン・オフライン問わず俯瞰的な視点で、最適なデジタルマーケティングをご提案いたします。
      </>
    ),
  },
  {
    icon: faMagnifyingGlass,
    label: 'SEO対策',
    id: 'seo',
    description: () => (
      <>
        Googleやyahoo!など検索エンジンで上位を狙うには、SEO対策が不可欠です。ApplyNowが制作するサイトでは、検索エンジンに内容を正確に伝えるための内部対策はもちろんのこと、ユーザーに高品質な内容を提供するためのページ構成や導線のご提案を行っています。
      </>
    ),
  },
  {
    icon: faWindowMaximize,
    label: 'オウンドメディア運用代行',
    id: 'ownedMedia',
    description: () => (
      <>
        WEBサイト、アプリ、メルマガなどオウンドメディアの運用代行サービスでは、経験豊富なメンバーによる専任チームを組成し、お客様の運用業務を巻き取ります。単純な作業のご提供ではなく、目標・ビジネスゴールを理解した制作運用を行うことで、オウンドメディアの成長につなげてまいります。
      </>
    ),
  },
  {
    icon: faUserTie,
    label: 'SNS運用代行',
    id: 'sns',
    description: () => (
      <>
        Facebook、LINE、twitterなどのSNSは企業の情報発信や顧客とのタッチポイント形成に欠かせない存在となりました。SNS運用代行サービスではライティング、撮影、画像加工等の制作から、投稿代行、投稿後のリアクションやインサイト分析のレポートまで一貫してサポートいたします
      </>
    ),
  },
  {
    icon: faChartLine,
    label: 'アクセス解析・改善支援',
    id: 'accessAnalysis',
    description: () => (
      <>
        <p className='mb-2'>GA4やヒートマップを導入した、サイトのアクセス解析、施策を行った際の効果測定が可能です。PDCAサイクルを通して改善を重ね、CVの増加や、ユーザビリティの向上につなげていくことができます。既に運営しているサイトがあるという企業様の場合も、弊社が調査した結果をもとにリニューアルも可能です。</p>
        <div className="flex items-center gap-x-2 w-full">
          <div className="w-24">
            <img
              src="/images/Partners/GAIQ.svg"
              width="205"
              height="181"
              alt="Google アナリティクス認定資格"
            />
          </div>
          <p>
            Google アナリティクス
            <br className="block md:hidden" />
            認定資格
            <br className="hidden md:block" />
            （GAIQ）
          </p>
        </div>
      </>
    ),
  },
]

const CreativeList = [
  {
    icon: faWindowMaximize,
    label: 'Webサイト制作',
    id: 'websiteProduction',
    description: () => (
      <>
        コーポレートサイト、採用サイト、サービスサイト、ランディングページ（LP）など、WEBサイトにはさまざまな目的のものがあります。
        <br />
        サイトの目的やご予算に応じ、最適な構成を検討しUI/UX・デザインをご提供いたします。イラストやアニメーションを取り入れたデザインも可能ですのでぜひお問い合わせください。
      </>
    ),
  },
  {
    icon: faMobileScreenButton,
    label: 'アプリデザイン',
    id: 'applicationDesign',
    description: () => (
      <>
        アプリ開発におけるデザイン制作は、アプリのユーザビリティを大きく左右する要素の一つです。
        <br />
        弊社ではプロトタイプを作成し実際の端末上での操作感を探りながら、アプリ内でのユーザー行動を理解し、最適なUI/UX設計をご提案いたします。
        <br />B to
        Cアプリのデザインに求められる、会員登録、クーポン、店舗検索、施設予約、モバイルオーダーなど、様々な機能を持つアプリのデザイン制作実績がございます。
      </>
    ),
  },
  {
    icon: faCompassDrafting,
    label: 'UI/UX設計改善',
    id: 'uiux',
    description: () => (
      <>
        どんなコンテンツにおいても、ユーザーが使いやすく、ストレスフリーに操作ができることが求められるものです。見た目の美しさやデザインだけでなく、提供するサービスの目的や価値を理解し、得られるUXを最大化することを目標にしたUI/UXをご提案いたします。
        <br />
        デザイン面だけでなく、読み込み速度の速さ、アクセシビリティなど様々な観点から追求しています。
      </>
    ),
  },
  {
    icon: faPenNib,
    label: '記事作成・ライティング',
    id: 'writing',
    description: () => (
      <>
        集客、ブランディング、採用など、WEBサイトの目的に応じて適切なライターや編集ディレクターを選定します。
        <br />
        課題をヒアリングした上で企画・構成案を作成し、各業界や分野の専門性に配慮した原稿をご提案いたします。既存のテキストの改善・リライトも対応いたします。
      </>
    ),
  },
  {
    icon: faCamera,
    label: 'インタビュー・写真撮影',
    id: 'interview',
    description: () => (
      <>
        取材先にカメラマンとライターがお伺いし、コーポレートサイトや採用サイトで重要なコンテンツとなる代表メッセージや社員インタビュー、導入事例紹介や開発者インタビューなどを作成させていただきます。
        <br />
        必要に応じてインタビューや座談会においてのファシリテートも代行いたします。
      </>
    ),
  },
  {
    icon: faCode,
    label: 'フロント開発',
    id: 'frontDevelop',
    description: () => (
      <>
        ApplyNowは、パソコン、スマートフォン、タブレットなど、様々なデバイスに柔軟に対応した高速なフロント開発を提供しています。ユーザビリティだけでなく、表示速度にもこだわり、高速で快適なUXの提供を目指しています。
      </>
    ),
  },
  {
    icon: faGear,
    label: 'CMS構築',
    id: 'cms',
    description: () => (
      <>
        <p className="mb-6">
          非エンジニアのご担当者の方にも簡単にサイトの更新を行っていただけるよう、CMS（管理画面）の構築が可能です。
          <br />
          WordPressやShopifyを使ったサイト構築や、また最近注目のmicroCMS（ヘッドレスCMS）を導入した、セキュアで自由度の高いサイト構築の実績もございます。
          <br />
          ※弊社はmicroCMSの公式パートナー企業です。
        </p>

        <div className="flex items-center">
          <div className="w-24">
            <img src="/images/Partners/microCMS.png" width="205" height="181" alt="microCMS" />
          </div>
          <p className="text-base md:text-lg">
            microCMS
            <br className="block md:hidden" />
            パートナー認定証
          </p>
        </div>
      </>
    ),
  },
]

export const ServiceView = memo(() => {
  const onClick = useCallback((id) => {
    scroller.scrollTo(`${id}`, {
      duration: 600,
      smooth: true,
      offset: -60,
    })
  }, [])

  return (
    <section className="relative pb-28 pt-16 md:pb-72 md:pt-32">
      <div className="container">
        <BreadCrumbs
          lists={[
            {
              label: 'サービスについて',
            },
          ]}
          className="mb-14 md:mb-20"
        />
        <div className="mb-10">
          <Heading as="h1" main="Service" sub="サービスについて" />
        </div>

        <div className="mb-10 flex justify-center gap-x-8 md:hidden">
          <button type="button" className="text-bg-blue" onClick={() => onClick('marketing')}>
            <div className="grid place-content-center justify-items-center md:gap-1">
              <span className="font-bold">マーケティング支援</span>
              <FontAwesomeIcon icon={faAngleDown} className="text-2xl" />
            </div>
          </button>
          <button type="button" className="text-bg-blue" onClick={() => onClick('creative')}>
            <div className="grid place-content-center justify-items-center md:gap-1">
              <span className="font-bold">クリエイティブ制作</span>
              <FontAwesomeIcon icon={faAngleDown} className="text-2xl" />
            </div>
          </button>
        </div>

        <div className="grid gap-x-16 md:grid-cols-[15rem_1fr]">
          <div className="hidden md:block">
            <Aside />
          </div>
          <div className="grid gap-y-16 md:gap-y-20">
            <div id="marketing">
              <Marketing />
            </div>
            <div id="creative">
              <Creative />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
})

const Aside = memo(() => {
  return (
    <aside className="sticky top-20">
      <div className="pt-5">
        <div className="mb-4 border-b-2 border-bg-blue pb-2 text-xl font-bold">
          マーケティング支援
        </div>
        <ul>
          {MarketingList.map((point, index) => {
            return (
              <li key={index}>
                <AsideNav {...point} />
              </li>
            )
          })}
        </ul>
      </div>
      <div className="pt-5 md:pt-12">
        <div className="mb-4 border-b-2 border-bg-blue pb-2 text-xl font-bold">
          クリエイティブ制作
        </div>
        <ul>
          {CreativeList.map((point, index) => {
            return (
              <li key={index}>
                <AsideNav {...point} />
              </li>
            )
          })}
        </ul>
      </div>
    </aside>
  )
})

type AsideNavProps = JSX.IntrinsicElements['div'] & {
  label: string
  id?: string
  icon: IconDefinition
}

const AsideNav = memo<AsideNavProps>(({ label, icon, id }) => {
  const onClick = useCallback((link) => {
    scroller.scrollTo(`${link}`, {
      duration: 600,
      smooth: true,
      offset: -50,
    })
  }, [])
  return (
    <button
      type="button"
      className="py-2.5 transition-opacity md:hover:opacity-50"
      onClick={() => onClick(id)}
    >
      <div className="flex items-center gap-4 text-bg-blue">
        <span>
          <FontAwesomeIcon icon={icon} className="text-base" />
        </span>
        <div className="text-left text-sm font-bold" dangerouslySetInnerHTML={{ __html: label }} />
      </div>
    </button>
  )
})

const Marketing = memo(() => {
  return (
    <div>
      <h2 className="mb-4 text-xl font-bold">マーケティング支援</h2>
      <div className="mb-4 pr-2 leading-loose">
        Webを活用した集客は、サイトが公開されてからのPDCA活動が重要です。デジタルマーケティング戦略の立案から運用・保守代行までを行いWebビジネスのさらなる育成をサポートします。
      </div>
      <div className="bg-bg-gray px-6 py-10 md:p-16">
        <ul className="grid gap-y-10 md:gap-y-12">
          {MarketingList.map((point, index) => {
            return (
              <li key={index}>
                <ServiceItem {...point} />
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
})

const Creative = memo(() => {
  return (
    <div>
      <h2 className="mb-4 text-xl font-bold">クリエイティブ制作</h2>
      <div className="mb-4 pr-2 leading-loose">
        デザイントレンドを抑えつつも、ユーザー目線でのUI設計を大切にし、画面の情報整理や各導線の強化、リブランディングなど、ビジネスの課題解決に貢献できるクリエイティブをご提供します。
      </div>
      <div className="bg-bg-gray px-6 py-10 md:p-16">
        <ul className="grid gap-y-12">
          {CreativeList.map((point, index) => {
            return (
              <li key={index}>
                <ServiceItem {...point} />
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
})

type ServiceItemProps = JSX.IntrinsicElements['div'] & {
  label: string
  id?: string
  icon: IconDefinition
  description: () => JSX.Element
}
const ServiceItem = memo<ServiceItemProps>(
  ({ label, icon, id, description, className, ...props }) => {
    return (
      <div id={id} className={`grid gap-y-4 md:gap-y-6 ${className}`} {...props}>
        <div className="flex items-center gap-3 text-bg-blue">
          <span>
            <FontAwesomeIcon icon={icon} className="text-2xl" />
          </span>
          <h3
            className="text-lg font-bold md:text-xl"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        </div>
        <div className="text-sm leading-loose text-bg-black300">{description()}</div>
      </div>
    )
  },
)
